import { Observable } from "rxjs";
import { CodeName, TimestampCustom } from "../common.http.interface";

export interface VehicleTypeOption {
    name?: string;
    code?: string;
}

export interface VehicleType {
    code?: string;
    name: string;
    description?: string;
    options?: VehicleTypeOption[];
    icon?: string;
    multiple?: boolean;
}

export interface VehicleTypeResponse {
    registrations: VehicleType[];
}

export interface VehicleTimestamps  {
    creationTimestamp: {
        timestamp: string;
    };
    modificationTimestamp: {
        timestamp: string;
    };

}

export interface InfoDgt {
    plate: string;
    label: string;
    category: string;
    municipality: string;
}

export enum ExceptionState {
    Pending = 'Pending',
    Attention = 'Attention',
    Revision = 'Revision',
    RevisionN2 = 'Revision N2',
    PreAccepted = 'Pre-Accepted',
    PreRejected = 'Pre-Rejected',
    Accepted = 'Accepted',
    Rejected = 'Rejected',
    Expired = 'Expired'
}

export interface Vehicle {
    applicantIdentifier: string;
    vehiclePlate: string;
    vehicleAlias: string;
    vehicleCountryCode: string;
    vehicleCountryName: string;
    creationTimestamp: TimestampCustom;
    modificationTimestamp: TimestampCustom;
    iconCategory: string;
    iconLabel: string;
    dgt: InfoDgt;
    municipalities: string[];
    exceptionState: ExceptionState;
    ownerDeclaration: boolean;
    // state: string;
    // municipalities: string[];
    // notifications: any[];
    // timestamps: VehicleTimestamps,
    // type: VehicleType;
    // attachments: Attachment[];
}

export interface PlateResponse {
    category: string;
    iconLabel: string;
    iconPlate: string;
    label: string;
    labelDescription: string;
    municipality: string;
    plate: string;
}

export interface VehiclesResponse {
    offset: number;
    limit: number;
    total: number;
    page: number;
    pages: number;
    elements: Vehicle[];
}

export interface VehicleRquest {
    vehiclePlate: string;
    vehicleAlias: string;
    vehicleCountryCode?: string;
    ownerDeclaration: boolean;
}

export interface ClassificationsResponse {
    classifications: CodeName[];
}

export interface FuelsResponse {
    fuels: CodeName[];
}

export interface IVehiclesService {

    // Vehicles
    getVehiclees(limit: number, offset: number): Observable<VehiclesResponse>;
    getVehicleesByApplicant(applicantId: string, limit: number, offset: number): Observable<VehiclesResponse>;
    getVehicle(plate: string, limit: number, offset: number): Observable<Vehicle>;
    addVehicle(newVehicle: VehicleRquest): Observable<Vehicle>;
    addVehiclesByApplicant(newVehicles: VehicleRquest[], documentNumber: string): Observable<Vehicle[]>;
    addVehicles(newVehicle: VehicleRquest[]): Observable<Vehicle[]>;
    updateVehicle(VehicleToUpdate: Vehicle): Observable<Vehicle>;
    deleteVehicle(VehiclePlate: string): Observable<string>;
    deleteVehicleByApplicant(vehiclePlate: string, documentNumber: string): Observable<string>

    // Vehicle Types
    getVehicleTypes(): Observable<VehicleTypeResponse>;

    // check plate
    checkPlate(plate: string): Observable<PlateResponse>;

    // mdm
    getClassifications(): Observable<ClassificationsResponse>;
    getFuels(): Observable<FuelsResponse>;
}